




























































import { Component, Vue } from 'vue-property-decorator';
import { Table } from 'element-ui';
import ActionBar from './components/ActionBar.vue';
import { requiredOnChange } from '@/shared/validation/rule';
import { IProductInfo } from '../../shared/models';

export enum EProductType {
  Active,
  Inactive,
}
@Component({
  name: 'Products',
  components: {
    ActionBar,
  },
})
export default class Products extends Vue {
  EProductType = EProductType;

  productType: EProductType = EProductType.Active;

  isLoading = false;

  selectedProductId: number | null = null;

  filterQuery = {
    name: '',
    price: 0,
    mt4: 0,
  };

  filterRules = {
    email: [requiredOnChange],
    phone: [requiredOnChange],
  };

  public listProduct: IProductInfo[] = [];

  protected created() {
    this.fetch();
  }

  protected handleCurrentChange(val: IProductInfo) {
    this.selectedProductId = val ? val.id || null : null;
  }

  protected clearSelect() {
    if (this.$refs.productTable) (this.$refs.productTable as Table).setCurrentRow(undefined);
  }

  private async fetch() {
    this.clearSelect();
    this.isLoading = true;
    this.listProduct = await this.$api.products.getListProduct();
    this.isLoading = false;
  }
}
